<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <kinva-doc-list
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"

            />
        </template>

         <add-button v-if="false && $store.getters.hasPermission('KINVADOC_CREATE')" @click="create"></add-button>

        <kinva-doc-create v-if="creating"
                        :open="creating"
                        v-on:itemCreated="onItemCreated"
                        v-on:close="creating=false"
        />

        <kinva-doc-update v-if="updating"
                        :open="updating"
                        :item="itemToEdit"
                        v-on:itemUpdated="onItemUpdated"
                        v-on:close="updating=false"
        />

        <kinva-doc-show v-if="showing"
                           :open="showing"
                           :item="itemToShow"
                           v-on:close="showing=false"
         />

        <kinva-doc-delete v-if="deleting"
                         :open="deleting"
                         :item="itemToDelete"
                         v-on:itemDeleted="onItemDeleted"
                         v-on:close="deleting=false"
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>

    import KinvaDocCreate from "../KinvaDocCreate";
    import KinvaDocUpdate from "../KinvaDocUpdate";
    import KinvaDocDelete from "../KinvaDocDelete";
    import KinvaDocShow from "../KinvaDocShow";
    import KinvaDocList from "../KinvaDocList";

     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"

    export default {
        name: "KinvaDocCrud",
        components: {
            CrudLayout, AddButton, Snackbar,
            KinvaDocCreate,
            KinvaDocUpdate,
            KinvaDocDelete,
            KinvaDocShow,
            KinvaDocList
        },
        data() {
            return {
                title: 'kinva.kinvaDoc.title',
                subtitle: 'kinva.kinvaDoc.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }

    }
</script>


